import SearchIcon from '@mui/icons-material/Search';
import { Box, Input } from '@mui/material';
import { ChangeEvent as ReactChangeEvent, useCallback } from 'react';
import { TableInstance } from 'react-table';
import { Product } from 'shared/types/product';

interface ProductSearchProps {
    instance: TableInstance<Product>;
}
export default function ProductSearch({ instance }: ProductSearchProps) {
    const {
        totalCount,
        setGlobalFilter,
        state: { globalFilter },
    } = instance;
    const onChange = useCallback(
        (event: ReactChangeEvent<HTMLInputElement>) => {
            setGlobalFilter(event.target.value || undefined);
        },
        [setGlobalFilter]
    );
    return (
        <Box display='flex' justifyContent='center' alignItems='center'>
            <div>
                <SearchIcon />
            </div>
            <Input
                type='search'
                value={globalFilter || ''}
                onChange={onChange}
                placeholder={`${totalCount} products...`}
            />
        </Box>
    );
}
